// API for the Safety toolbox talks page — read-only. Talks are uploaded from
// the mobile app; the web side lists them and streams the videos.

export const fetchToolboxTalks = async () => {
  const res = await fetch("/api/safety/toolbox-talks", {
    headers: { Accept: "application/json" },
  });
  const content = await res.json();
  if (!res.ok) throw new Error(content.error || "Request failed");
  return content;
};

// Streaming endpoint for a talk's video — used directly as a <video> src so
// the browser can seek via Range requests.
export const toolboxVideoUrl = (id) =>
  `/api/safety/toolbox-talks/${encodeURIComponent(id)}/video`;
